import { Box, Typography, useTheme } from "@mui/material";
import { AltArrowRight } from "@solar-icons/react/ssr";

const SeeAllRow = ({ href, label }) => {
    const theme = useTheme();
    return (
        <Box
            component="a"
            href={href}
            sx={{
                display: "flex",
                gap: "3px",
                alignItems: "center",
                px: "4px",
                py: "6px",
                textDecoration: "none",
                flexShrink: 0,
                "&:hover": { opacity: 0.75 },
            }}
        >
            <Typography
                sx={{
                    fontSize: 12,
                    color: "text.secondary",
                    fontFamily: "Inter Tight, sans-serif",
                    lineHeight: 1,
                }}
            >
                {label}
            </Typography>
            <AltArrowRight
                size={12}
                color={theme.palette.text.secondary}
                weight="Outline"
            />
        </Box>
    );
};

export default SeeAllRow;
